module.exports = __webpack_public_path__ + "img/3.95532290.jpg";